var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.1317 1030.3c-1.7133-0.2-3.2828 1.9-2.3574 3.5 1.0085 0.6 1.7478 2.5 0.4156 3.2-1.4115 0.8-3.3094-0.3-4.5597 0.9-1.0036 1.1-0.4643 2.7-0.5713 4.1-0.0217 2.6-0.0789 5.2 0.045 7.8 0.3157 1.3 1.7847 1.6 2.8961 1.6 0.9758 0 2.1118-0.1 2.6924-1 0.7582-1.2-0.8941-2-1.1993-3.1-0.5376-1.6 1.0693-3.1 2.6167-3 1.5032 0 3.0002 1.5 2.4872 3-0.548 1-2.0015 2.1-1.11 3.3 1.004 1 2.618 0.7 3.917 0.7 1.368-0.3 1.952-1.9 1.591-3.1-0.089-1.1 0.23-2.5 1.443-2.8 1.354-0.1 2.016 1.8 3.443 1.5 1.714-0.2 2.708-2.3 1.901-3.8-0.49-1.1-1.96-2-3.084-1.2-0.823 0.7-2.157 1.9-3.178 0.7-1.162-1.3 0.197-3.4-1.062-4.7-1.295-1.3-3.36 0.1-4.702-1.1-0.9711-0.8-0.271-2 0.397-2.8 1.192-1 0.372-3.1-1.022-3.6-0.319-0.1-0.6631-0.1-0.9993-0.1z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0938 1029.4c-1.7134-0.2-3.2828 1.9-2.3575 3.4 1.0085 0.7 1.7479 2.5 0.4156 3.3-1.4114 0.8-3.3093-0.4-4.5597 0.9-1.0035 1.1-0.4642 2.7-0.5712 4.1-0.0218 2.6-0.0789 5.2 0.045 7.8 0.3157 1.3 1.7846 1.5 2.896 1.5 0.9759 0.1 2.1118 0 2.6924-0.9 0.7582-1.3-0.894-2.1-1.1993-3.1-0.5375-1.6 1.0694-3.2 2.6167-3.1 1.5032 0 3.0002 1.6 2.4882 3.1-0.549 1-2.0024 2-1.111 3.2 1.004 1.1 2.618 0.8 3.917 0.7 1.368-0.3 1.952-1.8 1.591-3.1-0.089-1 0.23-2.5 1.443-2.7 1.354-0.1 2.016 1.8 3.443 1.5 1.714-0.2 2.708-2.3 1.901-3.8-0.49-1.1-1.96-2-3.084-1.3-0.823 0.8-2.157 2-3.178 0.8-1.162-1.4 0.197-3.4-1.062-4.8-1.295-1.3-3.36 0.1-4.702-1-0.971-0.8-0.271-2.1 0.397-2.8 1.192-1.1 0.372-3.1-1.022-3.6-0.3189-0.1-0.6631-0.1-0.9992-0.1z",
    fill: "#20677B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.2c6345afcfa9eb561b3066140d059e65.svg";
export { ForwardRef as ReactComponent };